<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">销售工具</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">短信</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-statistics">
            <div class="top-search" style="margin-bottom:0;padding-top:20px">
                <a-row type="flex">
                    <a-col><label for="">发送人：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" placeholder="今天" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">消耗套餐：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">发送时间：</label></a-col>
                    <a-col>
                        <a-select default-value="1" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                呼入
                            </a-select-option>
                            <a-select-option value="2">
                                呼出
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">使用场景：</label></a-col>
                    <a-col>
                        <a-select placeholder="全部" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                4G云网通
                            </a-select-option>
                            <a-select-option value="2">
                                云呼叫
                            </a-select-option>
                            <a-select-option value="2">
                                多卡全网通
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </div>
            
            <div class="table-content" >
                <a-table :columns="columns" :data-source="data">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '提交发送时间',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '短信内容',
    dataIndex: 'age',
    key: 'age',
    width: 80,
  },
  {
    title: '发送人',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true,
  },
  {
    title: '发送条数',
    dataIndex: 'address',
    key: 'address 2',
    ellipsis: true,
  },
  {
    title: '接发送人数',
    dataIndex: 'address',
    key: 'address 3',
    ellipsis: true,
  },
  {
    title: '使用渠道',
    dataIndex: 'address',
    key: 'address 4',
    ellipsis: true,
  },
  {
    title: '发送结果',
    dataIndex: 'time',
    key: 'time',
    ellipsis: true,
  }
];

const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park, New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 2 Lake Park, London No. 2 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park, Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];

export default {
    data(){
        return{
            data,
            columns,
        }
    },
    mounted(){
        this.drawLine()
    },
        methods:{
        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                xAxis: {
                    type: 'category',
                    data: ['2:00', '4:00', '6:00', '8:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'],
                    boundaryGap: false,
                },
                yAxis: {
                    name: '呼出/接听次数',
                    type: 'value'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#fff',
                            color: '#333'
                        },
                    }
                },
                grid: {  
                    left: '5%',  
                    right: '4%', 
                    top:'10%', 
                    bottom: '14%',  
                    containLabel: true  
                },  
                series: [{
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    smooth: true,
                    itemStyle: {
                        normal: {
                            color: '#bd48f9', //改变折线点的颜色
                            lineStyle: {
                                color: '#bd48f9' //改变折线颜色
                            }
                        }
                    },

                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset:0,
                                    color:'#e8c5fa'
                                },
                                {
                                    offset:1,
                                    color:'#fff'
                                }
                            ])
                        }
                    },
     
                }]
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/appalication/shortmessage.vue